import { initFormat } from '../../utils/formatObjects';
import { definitions } from './definitions';

export const initLanguagePack = () => {
    initFormat(definitions);
};
